import React, {Fragment, Component} from 'react';
import {Button} from 'reactstrap';
import {stringify} from 'query-string';
import { Link } from 'react-router-dom';
import { offers as offerApi } from '../../services/ApiService';
import { FMessage } from '../../hoc/IntlComponents';

const hrefPrefix = '//static.offerrum.com';

class LandingDownloadChooseFlowBlock extends Component {
  constructor(props) {
    super(props);
    const {streamId} = props;
    this.state = {
      loading: false,
      selectedFlowId: streamId ? streamId : null,
      selectedLandingId: 0,
      task_id: null,
      linkToFile: ''
    };
    this.interval = null;
  }

  componentDidMount() {
    const {inFlow, landingId} = this.props;
    const {selectedFlowId} = this.state;
    if(inFlow && selectedFlowId) {
      this.handleDownload({flowId: selectedFlowId, landingId});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(!prevState.task_id && this.state.task_id) {
      this.interval = this.getDownloadMethod();
    }
  }

  getTask = ({landingId, flowId}) => {
    offerApi.getLandingDownloadLink({landingId, streamId: flowId}).then(({task_id}) => {
      if(task_id) {
        this.setState(() => {
          return {
            task_id,
          }
        })
      }
    }).catch(() => this.props.closeFn());
  }

  getDownloadMethod = () => setInterval(() => {
    offerApi.getLandingDownloadItem({taskId: this.state.task_id}).then(({items}) => {
      if(items[0].file) {
        window.clearInterval(this.interval);
        this.setState(() => {
          return {
            loading: false,
            linkToFile: items[0].file,
          };
        });
      }
    })
  }, 3000);

  handleDownload = ({flowId, landingId = 0}) => {
    this.setState(() => {
      return {
        loading: true,
        selectedFlowId: flowId,
        selectedLandingId: landingId,
      };
    })
    this.getTask({landingId, flowId})
  }

  componentWillUnmount() {
    window.clearInterval(this.interval);
  }

  renderHeaderMessage = () => {
    const {
      site_key,
      offer,
    } = this.props;
    const {
      selectedFlowId,
      linkToFile,
      loading,
    } = this.state;
    const {modifies: {is_my}, flows} = offer;
    if(!site_key) {
      return <FMessage id="transfer-by-api.download.header.no-sitekey"/>;
    }
    if(!is_my) {
      return <FMessage id="transfer-by-api.download.header.no-offer"/>;
    }
    if(!flows.length) {
      return <FMessage id="transfer-by-api.download.header.no-streams"/>;
    }
    if(!selectedFlowId) {
      return <FMessage id="flow.errors.no-flow"/>;
    }
    if(loading) {
      return <FMessage id="transfer-by-api.modal.wait"/>;
    }
    if(!loading && linkToFile) {
      return <FMessage id="transfer-by-api.modal.download.ready.header"/>;
    }
    return null;
  }

  getLandingParams = () => {
    const {
      offer,
      landingId,
      name,
    } = this.props;
    const params = {}
    if(offer && offer.id) {
      params.offer = offer.id;
    }
    if(name !==  'prelanders') {
      params.landing = landingId;
    } else {
      params.prelanding = landingId;
    }
    return stringify(params);
  }

  renderTroubleBtns = () => {
    const {
      site_key,
      offer,
      connectOffer,
      landingId,
    } = this.props;
    const {
      selectedFlowId,
      linkToFile,
      loading,
    } = this.state;
    const {modifies: {is_my}, flows} = offer;

    const commonBtnProps = {
      type: "button",
      size: "md",
      color: "primary",
      outline: true,
    };
    if(!site_key) {
      return (
        <Link
          to={{
            pathname: "/tickets/create",
            search: "?sitekey=site_key",
          }}
          className="btn btn-primary btn-md outline"
        >
          <FMessage id='transfer-by-api.download.no-sitekey.btn'/>
        </Link>
      );
    }
    if(!is_my) {
      return (
        <Button
          {...commonBtnProps}
          onClick={connectOffer}
        >
          <FMessage id='offer.top-link.connect-offer'/>
        </Button>
      );
    }
    if(!flows.length) {
      return (
        <Link
          to={`/tools/flows/create?${this.getLandingParams()}`}
          className="btn btn-primary btn-md outline"
        >
          <FMessage id='flows.buttons.add-flow'/>
        </Link>
      );
    }
    if(!selectedFlowId) {
      return (
        <Fragment>
          {flows.map((flow, key) => {
            return <Button
              key={key}
              {...commonBtnProps}
              onClick={() => this.handleDownload({flowId: flow.id, landingId})}
              >
                {flow.title}
              </Button>
            })
          }
        </Fragment>
      );
    }
    if(!loading && linkToFile) {
      return (
          <div className='download-btn'>
            <a href={hrefPrefix + linkToFile} className='btn btn-md btn-primary'>
              <FMessage id="transfer-by-api.modal.download.ready.btn"/>
            </a>
          </div>
      );
    }
  }

  renderMessage = () => {
    const {
      site_key,
      offer,
      name,
    } = this.props;
    const {
      linkToFile,
      loading,
    } = this.state;
    const {modifies: {is_my}, flows} = offer;

    if(name !== 'prelanders') {
      if(!site_key) {
        return <FMessage id="transfer-by-api.download.message.no-sitekey.1"/>;
      }
      if(!is_my) {
        return <FMessage id="transfer-by-api.download.no-stream-no-offer.landing"/>;
      }
      if(!flows.length) {
        return <FMessage id="transfer-by-api.download.no-stream.landing"/>;
      }
    } else {
      if(!site_key) {
        return <FMessage id="transfer-by-api.download.message.no-sitekey.2"/>;
      }
      if(!is_my) {
        return <FMessage id="transfer-by-api.download.no-stream-no-offer.prelanding"/>;
      }
      if(!flows.length) {
        return <FMessage id="transfer-by-api.download.no-stream.prelanding"/>;
      }
    }

    if(loading && !linkToFile) {
      return <FMessage id="transfer-by-api.modal.download.process"/>;
    }
    return '';
  }

  render() {
    return (
      <Fragment>
        <h5><b>{this.renderHeaderMessage()}</b></h5>
        {this.renderMessage()}
        <div className='trouble-buttons flows-buttons'>{this.renderTroubleBtns()}</div>
      </Fragment>
    );
  }
}

export default LandingDownloadChooseFlowBlock;